module.exports = __webpack_public_path__ + "img/GitHub-hover.bd222f79.svg";